import EvaluationBase from "./evaluation-base";

export default EvaluationBase;